import {Helper} from '../helper/Helper';

export default {
    init() {
        if (location.pathname.includes('entity-search')) {
            this.ensureOrgRelatedModal();
            this.searchListeners();
            this.selectEntity();
            // this.initOrgRelatedModalListeners();
            this.orgEntitiesModalListeners();
            this.showPreviewEditEntityModal();
            this.deleteingOrganisation();
            this.editEntityListeners();
            this.helper = new Helper();
            this.currentOrganisationId = 0;
            this.currentOrganisationName = '';
            this.customersTimer = null;
            this.usersTimer = null;
        }
    }, 

    ensureOrgRelatedModal() {
        if ($('#org-related-modal').length) return;

        $('body').append(`
            <div class="modal fade" id="org-related-modal" tabindex="-1" role="dialog" aria-hidden="true" aria-labelledby="org-related-modal-label">
                <div class="modal-dialog modal-m" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <div class="modal-title font-weight-bold" id="org-related-modal-label">Organization</div>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="mb-4">
                                <div class="font-weight-bold mb-2" id="org-related-customers-title">
                                    Customers of <span class="text-primary" id="org-related-name-customers"></span> (0)
                                </div>
                                <input id="org-related-customers-search" type="text" class="bb-standard-input w-100" placeholder="Search" autocomplete="nope">
                                <div id="org-related-customers-list" class="org-related-modal-list mt-3"></div>
                            </div>

                            <div>
                                <div class="font-weight-bold mb-2" id="org-related-users-title">
                                    Users of <span class="text-primary" id="org-related-name-users"></span> (0)
                                </div>
                                <input id="org-related-users-search" type="text" class="bb-standard-input w-100" placeholder="Search" autocomplete="nope">
                                <div id="org-related-users-list" class="org-related-modal-list mt-3"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        `);
    },

    searchListeners() {
        $('.entity-select').on('change', (e) => {
            const selectedValue = $(e.currentTarget).val();
            
            document.title = this.helper.strToUpper(selectedValue) + ' Management';
            $('.breadcrumbs.title').text(this.helper.strToUpper(selectedValue) + ' Management');
            $('.search-bar-dropdown').html('');
            $('#entity-search-selected').html('');
            $('#entity-search-results-list').html('');
        });

        $('.search-btn').on('click', () => {
            $('.search-bar-dropdown').html('');
            this.searchEntity('button');
        });
        $('body').on('keyup', '.search-bar', (e) => {           
            if( e.code === 'Enter' || e.code === 'NumpadEnter') this.searchEntity('button');
            else if($(e.currentTarget).val().length > 0){
                const tO = setTimeout(() => {
                    this.searchEntity('input');
                }, 800);
                clearTimeout(tO-1);
            } 
        })
    },

    searchEntity(point = 'input'){
        const searchValue = ($('.search-bar').val() || '').trim();
        let searchType = $('.entity-select').val();

        const $resultsList = $('#entity-search-results-list');
        const $selected = $('#entity-search-selected');

        if (!searchValue) {
            $resultsList.addClass('d-none');
            $resultsList.html('');
            $selected.addClass('d-none');
            $selected.html('');
            return;
        }
        let url, method, data;
        if (point === 'input') {
            url = '/admin/entity-search/search';
            method = 'POST';
            data = {
                search_type: searchType,
                search_value: searchValue,
                search_point: 'input',
            };
        } else {
            url = '/admin/entity-search/filter';
            method = 'GET';
            searchType = 'search-' + searchType;
            data = {
                entity_class: searchType,
                search_value: searchValue,
            };
        }

        // On a new search hide info block and show the list placeholder.
        $selected.addClass('d-none');
        $selected.html('');
        $resultsList.removeClass('d-none');
        $resultsList.html('');

        // Request entities for the inline results list.
        $.ajax({
            // url: '/admin/entity-search/search',
            url: url,
            type: method,
            data: data,
            success: (entities) => {
                if (point === 'input') {
                    const dropdownList = $('.search-bar-dropdown');
                    dropdownList.html('');
                    entities.forEach(entity => {
                        if (searchType === 'organizations') {
                            dropdownList.append(`
                                <div class="entity-search-result-row" data-entity-id="${entity.id}" data-entity-type="${searchType}">
                                    ${entity.id}. ${entity.name}
                                    <span class="text-muted">${entity.org_email} ${entity.twilio_phone ?? 'without phone'}</span>
                                </div>
                            `);
                        } else {
                            dropdownList.append(`
                                <div class="entity-search-result-row" data-entity-id="${entity.id}" data-entity-type="${searchType}">
                                    ${entity.id}. ${entity.first_name} ${entity.last_name}
                                    <span class="text-muted">${entity.email} ${entity.phone}</span>
                                </div>
                            `);
                        }
                    });
                } else {
                    if (Array.isArray(entities.view)) {
                        entities.view.forEach(view => {
                            $resultsList.append(view);
                        });
                    } else {
                        $resultsList.html(entities.view);
                    }
                }
            }
        });
    },

    selectEntity() {
        $(document).on('click', '.entity-search-show-btn, .org-related-modal-row, .entity-search-result-row, .select-entity', function (e) {
            e.preventDefault();
            $('.search-bar-dropdown').html('');

            const entityId = $(this).data('entity-id');
            const entityType = $(this).data('entity-type');

            if (!entityId || !entityType) return;

            $.ajax({
                url: '/admin/entity-search/get-entity',
                type: 'POST',
                data: {
                    entity_type: entityType,
                    entity_id: entityId,
                    search_point: 'related_table',
                },
                success: function (response) {
                    $('.modal').modal('hide');
                    if (Array.isArray(response.relations)) {
                        $('#entity-search-selected').html(`${response.entity_info}`);
                        response.relations.forEach(relation => {
                            if (relation.toString().includes('User Name')) {
                                $('#entity-search-selected').append("<div class='title mt-2' style='font-size:18px;'>Users</div>");
                            } else if (relation.toString().includes('Customer Name')) {
                                $('#entity-search-selected').append("<div class='title mt-2' style='font-size:18px;'>Customers</div>");
                            }
                
                            $('#entity-search-selected').append(relation);
                        });
                    } else {
                        $('#entity-search-selected').html(`${response.entity_info}${response.relations}`);
                    }
                    $('#entity-search-selected').removeClass('d-none');
                    $('#entity-search-results-list').addClass('d-none');
                },
            });
        });
    },

    orgEntitiesModalListeners() {
        $(document).on('click', '.entity-org-preview, .show-entity-users', (e) => {
            
            if ($(e.target).hasClass('show-preview-entity-btn')) {
                return;
            }
            e.preventDefault();
            e.stopPropagation();

            const organisationId = $(e.currentTarget).data('entity-id');
            const organisationName = $(e.currentTarget).data('entity-name');
            if (!organisationId) return;

            this.openOrganisationModal(organisationId, organisationName);
        });

        $('#org-related-customers-search').on('input',  (e) => {
            const q = $(e.currentTarget).val();
            clearTimeout(this.customersTimer);
            this.customersTimer = setTimeout(() => {
                this.loadCustomers(q);
            }, 300);
        });

        $('#org-related-users-search').on('input',  (e) => {
            const q = $(e.currentTarget).val();
            clearTimeout(this.usersTimer);
            this.usersTimer = setTimeout(() => {
                this.loadUsers(q);
            }, 300);
        });
    },

    openOrganisationModal(organisationId, organisationName) {
        this.currentOrganisationId = organisationId;
        this.currentOrganisationName = organisationName || '';

        $('#org-related-modal-label').text(organisationName || 'Organisation');
        $('#org-related-customers-title').html('Customers of <span id="org-related-name-customers"></span> (0)');
        $('#org-related-users-title').html('Users of <span id="org-related-name-users"></span> (0)');
        $('#org-related-name-customers').text(this.currentOrganisationName);
        $('#org-related-name-users').text(this.currentOrganisationName);

        $('#org-related-customers-search').val('');
        $('#org-related-users-search').val('');
        $('#org-related-customers-list').html('');
        $('#org-related-users-list').html('');

        // Show first 4 by default
        $('#org-related-modal').modal('show');
        this.loadCustomers('');
        this.loadUsers('');
    },

    loadUsers(q) {
        const $list = $('#org-related-users-list');
        if (!this.currentOrganisationId) return;

        this.setListLoading($list);
        $.post('/admin/entity-search/org-users', {
            organisation_id: this.currentOrganisationId,
            q: q || ''
        }).done((res) => {
            $('#org-related-users-title').html(
                'Users of <span id="org-related-name-users"></span> (' + (res.count || 0) + ')'
            );
            $('#org-related-name-users').text(this.currentOrganisationName);
            $list.html(res.itemsHtml || '');
        }).fail(function () {
            $list.html('<div class="text-center text-muted py-2">Error</div>');
        });
    },

    loadCustomers(q) {
        const $list = $('#org-related-customers-list');
        if (!this.currentOrganisationId) return;

        this.setListLoading($list);
        $.post('/admin/entity-search/org-customers', {
            organisation_id: this.currentOrganisationId,
            q: q || ''
        }).done((res) => {
            $('#org-related-customers-title').html(
                'Customers of <span id="org-related-name-customers"></span> (' + (res.count || 0) + ')'
            );
            $('#org-related-name-customers').text(this.currentOrganisationName);
            $list.html(res.itemsHtml || '');
        }).fail(function () {
            $list.html('<div class="text-center text-muted py-2">Error</div>');
        });
    },

    setListLoading($el) {
        $el.html('<div class="text-center text-muted py-2">Loading...</div>');
    },

    showPreviewEditEntityModal() {
        $('body').on('click','.show-preview-entity-btn',function() {
            const entityType = $(this).data('entity-type');
            const entityId = $(this).data('entity-id');

            $.ajax({
                url: '/admin/entity-search/get-entity-preview',
                type: 'POST',
                data: {
                    entity_type: entityType,
                    entity_id: entityId,
                },
                success: (response) => {
                    $('#form-container').html(response);
                    $('#entity-preview-modal').modal('show');
                },
                error: (error) => {
                    console.error(error);
                }
            });
        });
    },

    editEntityListeners() {
        /**
         * Customers
         */
        $('body').on('click', '.customer_info_edit', function(e) {
            e.preventDefault();
            let id = $(this).data('id');
            $('.modal').modal('hide');
            $.ajax({
                type: 'GET',
                url: '/admin/customer_info_edit/' + id,
                success: function (response) {
                    $('#form-container-s').html(response);
                    // Mask
                    $('#phone').mask('000-000-0000');
                    $('#phone').off('paste').on('paste', function(e) {
                        e.preventDefault();
                        let pastedData = e.originalEvent.clipboardData.getData('Text');
                        let digits = pastedData.replace(/\D/g, '');
                        if (digits.length > 10) {
                            digits = digits.slice(-10);
                        }
                        $(this).val(digits);
                        $(this).trigger('input');
                    });
                },
                complete: function() {
                    $('#customer_info_edit_modal').modal('show');
                }
            });
        });

        $('body').on('click', '.admin-update-customer-btn', function(event) {
            event.preventDefault();
            $('.alert').addClass('d-none')
                .removeClass('alert-danger')
                .removeClass('alert-success')
                .text('');
            if($('.user-info-edit-phone').val().length < 12) {
                $('#label-phone-alert').css('display','block');
            } else {
                let form = $(this).closest('form')[0];
                let data = new FormData(form);
                $.ajax({
                    type: 'POST',
                    url: '/admin/customer_info_update',
                    data: data,
                    processData: false,
                    contentType: false,
                    beforeSend: () => {
                        $(this).prop('disabled', true);
                    },
                    success: function (response) {
                        if(response.success) {
                            $('.alert')
                                .removeClass('d-none')
                                .removeClass('alert-danger')
                                .addClass('alert-success')
                                .text(response.message);
                                setTimeout(() => {
                                    $('.modal').modal('hide');
                                }, 1500);
                        }
                    },
                    error: function (response) {
                        $('.alert')
                            .removeClass('d-none')
                            .removeClass('alert-success')
                            .addClass('alert-danger');
                        let alert_text = '<ul>';
                        $.each(response.responseJSON.errors, function (index, value) {
                            alert_text += '<li>' + value + '</li>';
                        });
                        $('.alert').html(alert_text+'</ul>');
                    },
                    complete: () => {
                        $(this).prop('disabled', false);
                    }
                });
            }
        });
        /**
         * Users 
         */
        $('body').on('click', '.user_info_edit', function(e) {
            e.preventDefault();
            let id = $(this).data('id');
            const isOrgCockpitPage = /^\/cockpit\//.test(window.location.pathname);
            if (!isOrgCockpitPage) {
                $('.modal').modal('hide');
            }
            if (isOrgCockpitPage) {
                return;
            }
            $.ajax({
                type: 'GET',
                url: '/admin/user_info_edit/' + id,
                success: function (response) {
                    if (/^\/cockpit\//.test(window.location.pathname)) {
                        return;
                    }
                    $('#form-container-s').html(response);
                    // Mask
                    $('#phone').mask('000-000-0000');
                },
                complete: function() {
                    if (/^\/cockpit\//.test(window.location.pathname)) {
                        return;
                    }
                    $('#user_info_edit_modal').modal('show');
                }
            });
        });
        $('body').on('click', '#developer', function(e) {
            let data = {
                user_id: $(this).data('id'),
                developer: $(this).is(':checked') ? 1 : 0,
            };
            $.ajax({
                type: 'PUT',
                url: '/admin/user_info_update',
                data: data,
                success: function (response) {
                    if(response.success) {
                        $('.alert')
                            .removeClass('d-none')
                            .removeClass('alert-danger')
                            .addClass('alert-success')
                            .text(response.message);
                    }
                },
                error: function (response) {
                    $('.alert')
                        .removeClass('d-none')
                        .removeClass('alert-success')
                        .addClass('alert-danger');
                    let alert_text = '<ul>';
                    $.each(response.responseJSON.errors, function (index, value) {
                        alert_text += '<li>' + value + '</li>';
                    });
                    $('.alert').html(alert_text+'</ul>');
                }
            });
        })

        /**
         * Teams
         */
        $('body').on('click', '.team_info_edit', function(e) {
            e.preventDefault();
            let id = $(this).data('id');
            $('.modal').modal('hide');
            $.ajax({
                type: 'GET',
                url: '/admin/team_info_edit/' + id,
                success: function (response) {
                    $('#form-container-s').html(response);
                    // Mask
                    $('#phone').mask('000-000-0000');
                    $('#phone').off('paste').on('paste', function(e) {
                        e.preventDefault();
                        let pastedData = e.originalEvent.clipboardData.getData('Text');
                        let digits = pastedData.replace(/\D/g, '');
                        if (digits.length > 10) {
                            digits = digits.slice(-10);
                        }
                        $(this).val(digits);
                        $(this).trigger('input');
                    });
                },
                complete: function() {
                    $('#team_info_edit_modal').modal('show');
                }
            });
        });

        $('body').on('click', '.team-info-submit-form', function(event) {
            event.preventDefault();
            $('.alert').addClass('d-none')
                .removeClass('alert-danger')
                .removeClass('alert-success')
                .text('');
            if($('.user-info-edit-phone').val().length < 12) {
                $('#label-phone-alert').css('display','block');
            } else {
                let form = $(this).closest('form')[0];
                let data = new FormData(form);
                $.ajax({
                    type: 'POST',
                    url: '/admin/team_info_update',
                    data: data,
                    processData: false,
                    contentType: false,
                    success: function (response) {
                        if(response.success) {
                            $('.alert')
                                .removeClass('d-none')
                                .removeClass('alert-danger')
                                .addClass('alert-success')
                                .text(response.message);
                        }
                    },
                    error: function (response) {
                        $('.alert')
                            .removeClass('d-none')
                            .removeClass('alert-success')
                            .addClass('alert-danger');
                        let alert_text = '<ul>';
                        $.each(response.responseJSON.errors, function (index, value) {
                            alert_text += '<li>' + value + '</li>';
                        });
                        $('.alert').html(alert_text+'</ul>');
                    }
                });
            }
        });

        $('body').on('click','#team-info-form #reset_email', function (e) {
            e.preventDefault()
            $('#email_edit_confirmation').modal('show')
        })
        $('body').on('click', '#email_edit_confirmation .edit-agreed', function () {
            let id = $(this).data('id');
            $.ajax({
                type: 'GET',
                url: '/admin/team_info_email_reset/' + id,
                success: function (response) {
                    if(response.success) {
                        $('.alert')
                            .removeClass('d-none')
                            .removeClass('alert-danger')
                            .addClass('alert-success')
                            .text(response.message);
                        $('#team-info-form #email').val('')
                    //window.location.reload()
                    }
                },
                error: function (response) {
                    $('.alert')
                        .removeClass('d-none')
                        .removeClass('alert-success')
                        .addClass('alert-danger');
                    let alert_text = '<ul>';
                    $.each(response.responseJSON.errors, function (index, value) {
                        alert_text += '<li>' + value + '</li>';
                    });
                    $('.alert').html(alert_text+'</ul>');
                },
            });
        });

        $('body').on('click', '#send_port_numer_request_button', function() {
            let organisation_id = $(this).data('id');

            $.ajax({
                type: 'post',
                url: '/admin/organization-management/port-number/send-email',
                data: {
                    organisation_id: organisation_id,
                    status: 0,
                },
                success: function(response) {
                    $('#send_port_numer_request_modal').modal('hide');
                    alert("Email send");
                },
            });
        });
    },

    deleteingOrganisation(){
        $('body').on('click','.org_delete_btn',function(e) {
            e.preventDefault();
            const org_id = $(this).data('org_id');
            $('.modal').modal('hide');
            $('#confirm_delete_organisation_modal').modal('show');
            $('#confirm_delete_organisation_modal').find('.confirm_delete_organisation').data('org_id', org_id);
        })
        $('#confirm_delete_organisation_modal').on('click', '.confirm_delete_organisation', function(e) {
            e.preventDefault();
            console.log($(e.target).data('org_id'), $(this).data('org_id'));
            const org_id = $(e.target).data('org_id');
            if (org_id > 0) {
                $.ajax({
                    type: 'POST',
                    url: '/admin/delete-team',
                    data: {
                        'organisation_id': org_id,
                    },
                    success: (response) => {
                        if (response.result == true) {
                            window.location.href = '/admin/admin-edit-team';
                        }
                    },
                    error: (response) => {
                        $('#confirm_delete_organisation_modal').modal('hide');
                        $('#error-deleting-organisation-modal').modal('show');
                        const auto_ticket = new AutoTicket('#error-deleting-organisation-modal', '.create-ticket-button');
                        if (response.message) {
                            $('#error-deleting-organisation-modal').find('.result_message').text(response.message);
                            auto_ticket.createAutoTicket("Something went wrong when deleting an organization", JSON.stringify(response.responseJSON.description));
                        }else{
                            auto_ticket.createAutoTicket("Something went wrong when deleting an organization", JSON.stringify(response.responseJSON.description));
                        }
                    }
                });
            }
        })
    },
}